import { MessagePinnedByOtherEvent, MessagePinnedByYouEvent, MessageUnPinnedByOtherEvent, MessageUnPinnedByYouEvent, PartialHistoryMessageItem } from '@wui/im'

import { useLocalization } from '@/shared/composables/localization'

export const getPinnedEventText = (
  event: PartialHistoryMessageItem<
    MessagePinnedByOtherEvent |
    MessagePinnedByYouEvent |
    MessageUnPinnedByOtherEvent |
    MessageUnPinnedByYouEvent
  >): string => {
  const { t } = useLocalization()
  switch (event.item.type) {
  case 'PinnedMessageEvent': {
    return t('common.userPinMessageBy')
  }
  default: {
    return t('common.userUnPinMessageBy')
  }
  }
}
